<div class="table-wrapper" *transloco="let t; prefix: 'assetShared.breakdownTable'">
  <table class="breakdown-table">
    <thead>
      <tr>
        <th>{{ t('factor') }}</th>
        <th>{{ t('lastMonth') }}</th>
        <th>{{ t('thisMonth') }}</th>
        <th>{{ t('change') }}</th>
        <th>{{ t('impactOnEfficiency') }}</th>
      </tr>
    </thead>
    <tbody>
      @if (showLoading) {
        <tr class="loading-row">
          <td colspan="5" class="text-center">
            <span class="spinner-border"></span>
          </td>
        </tr>
      }
      @if (!showLoading) {
        @for (item of data; track item.factor) {
          <tr>
            <td>
              <strong>{{ item.factor }}</strong>
            </td>
            <td>{{ item.previousValue }}</td>
            <td>{{ item.currentValue }}</td>
            <td>{{ item.change }}</td>
            <td>
              <span class="impact-badge" [ngClass]="getImpactClass(item.impactOnEfficiency)">
                @if (item.impactOnEfficiency === 'Increased on Efficiency') {
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M7.9987 1.33594C4.3227 1.33594 1.33203 4.3266 1.33203 8.0026C1.33203 11.6786 4.3227 14.6693 7.9987 14.6693C11.6747 14.6693 14.6654 11.6786 14.6654 8.0026C14.6654 4.3266 11.6747 1.33594 7.9987 1.33594ZM6.66603 10.9446L4.1907 8.4746L5.13203 7.5306L6.6647 9.0606L10.194 5.53127L11.1367 6.47394L6.66603 10.9446Z"
                      fill="#50AD41" />
                  </svg>
                } @else if (item.impactOnEfficiency === 'Stable' || item.impactOnEfficiency === 'stable') {
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M7.9987 1.33594C4.3227 1.33594 1.33203 4.3266 1.33203 8.0026C1.33203 11.6786 4.3227 14.6693 7.9987 14.6693C11.6747 14.6693 14.6654 11.6786 14.6654 8.0026C14.6654 4.3266 11.6747 1.33594 7.9987 1.33594ZM6.66603 10.9446L4.1907 8.4746L5.13203 7.5306L6.6647 9.0606L10.194 5.53127L11.1367 6.47394L6.66603 10.9446Z"
                      fill="#50AD41" />
                  </svg>
                } @else {
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M8.00065 1.33203C4.32465 1.33203 1.33398 4.3227 1.33398 7.9987C1.33398 11.6747 4.32465 14.6654 8.00065 14.6654C11.6767 14.6654 14.6673 11.6747 14.6673 7.9987C14.6673 4.3227 11.6767 1.33203 8.00065 1.33203ZM8.66732 11.332H7.33398V9.9987H8.66732V11.332ZM8.66732 8.66536H7.33398V4.66536H8.66732V8.66536Z"
                      fill="#FF7F00" />
                  </svg>
                }
                {{ getImpactLabel(item) }}
              </span>
            </td>
          </tr>
        }
      }
    </tbody>
  </table>
</div>